<template>
  <footer>
    <BittsButton
      text="Remove integration"
      :left-icon="['fak', 'delete']"
      variant="ghost"
      type="danger"
      data-testid="delete-integration-button"
      @click="emit('remove-integration')"
      :disabled="isDeleting || isSaving"
    />
    <BittsButton
      :text="saveButtonText"
      :disabled="disableSaveButton || isDeleting || isSaving"
      :loading="isSaving"
      @click="emit('save')"
    />
  </footer>
</template>
<script setup lang="ts">
import { BittsButton } from '@crossbeam/bitts';

defineProps<{
  isDeleting: boolean;
  isSaving: boolean;
  disableSaveButton?: boolean;
  saveButtonText: string;
}>();

const emit = defineEmits<{
  'remove-integration': [];
  save: [];
}>();
</script>

<style scoped lang="pcss">
footer {
  @apply flex justify-between border-t border-neutral-border p-16 sticky bottom-0 bg-white w-full z-10;
}
footer::before {
  position: absolute;
  content: '';
  height: 14px;
  top: -14px;
  background: linear-gradient(to bottom, rgb(0 0 0 / 0%), rgb(0 0 0 / 6%));
  left: 0;
  width: 100%;
}
</style>
